import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';

import * as a from './../../../libs/actions';
import * as aggs from "../../../libs/aggregation";
import { getSocketStore } from '../../../libs/utils';
import { Head } from '../../ui/head';
import { CHAT_STATUS_ACTIVE } from '@evo/chat-core';

class HeaderView extends React.Component {

    static propTypes = {
        closeDialog: PropTypes.func,
        hasUnreadMessage: PropTypes.bool,
    };

    handleChangeClientTab = () => {
        this.props.send(a.EVENT_CLIENT_BACK_TAB);
    }

    render() {
        const { closeDialog, hasUnreadMessage } = this.props;

        return (
            <Head
                dataQa='chat_header'
                hasUnreadMessage={hasUnreadMessage}
                onBack={this.handleChangeClientTab}
                onClose={closeDialog}

            >
                <span title={t`Информация о покупателе`}>
                    {t`Информация о покупателе`}
                </span>
            </Head>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);

    return {
        hasUnreadMessage: aggs.hasUnreadMessage(
            socketStore.get('chats'),
            CHAT_STATUS_ACTIVE
        )
    }
};

export const Header = connect(mapStateToProps)(HeaderView);
